import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import ModalPopup from '@ui/components/VnModal';
import { addOutline } from 'ionicons/icons';
import AddContactForm from './AddContactForm';
import { useState } from 'react';
import { useAppDispatch } from '@application/store/useStore';
import { useParams } from 'react-router-dom';
import { getContactPersonByIdAsync } from '@application/features/debtors/debtorThunk';
import ContactPersonTable from './ContactPersonTable';
import { clearContactPerson } from '@application/features/debtors/debtorSlice';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
const ContactPersonTab = ({ isContactPersonTabBold }) => {
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const [isAddContactFormVisible, SetAddContactFormVisible] = useState(false);
    const onAddContactFormCloseClicked = () => {
        SetAddContactFormVisible(false);
        dispatch(clearContactPerson());
    };
    const onRowClick = (id) => {
        dispatch(getContactPersonByIdAsync(id));
        SetAddContactFormVisible(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'vn-Material-Add-buttons', children: _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button mt-1 mb-3 ml-2', icon: addOutline, isDisabled: handleRolePermission(Permission.KLANTEN, PermissionType.Create) && id ? false : true, onClick: () => {
                        SetAddContactFormVisible(true);
                    }, children: "Toevoegen Contactpersoon" }) }), _jsx(ModalPopup, { title: 'Toevoegen Contactpersoon', content: _jsx(AddContactForm, { onClose: () => onAddContactFormCloseClicked(), isContactPersonTabBold: isContactPersonTabBold }), onOpen: isAddContactFormVisible, onClose: () => onAddContactFormCloseClicked(), modalWidth: 'lg' }), _jsx(ContactPersonTable, { onRowClick: onRowClick, isContactPersonTabBold: isContactPersonTabBold })] }));
};
export default ContactPersonTab;
